import { withNamespaces } from "react-i18next";
import { useMemo } from "react";
import {
    Col,
    Container,
    Row
} from 'reactstrap';
import { useParams, useHistory, useLocation } from "react-router-dom";
import Navigator from "src/modules/3rd-party-management/components/navigator";
import ResultBody from "./components/result-body";

const ResultDetailPage = ({ t }) => {
    const history = useHistory();
    const params = useParams();
    const location = useLocation();

    const navigatorOptions = useMemo(() => {
        return {
            backButtonOptions: () => {
                return {
                    enable: true,
                    title: t("Back"),
                    icon: <i className="ri-arrow-left-fill"></i>,
                    onClick: () => history.goBack() 
                }
            },
            breadCrumbs: [
                {
                    title: t("SIP"),
                    link: "/admin/3rd-party/dashboard"
                },
                {
                    title: "Compliance Screening",
                    link: "/admin/3rd-party/compliance/screening?tab=overview"
                },
                {
                    title: t("Detail"),
                    link: "#"
                }
            ],
            pageTitle: 'Compliance Screening'
        }
    }, [ t ]);

    const searchParams = new URLSearchParams(location.search);

    return (
        <div className="page-content">
            <Container fluid>
                <Row>
                    <Col lg="12" className="mb-4">
                        <Navigator {...navigatorOptions} />
                    </Col>

                    <Col lg="12" className="mb-4">
                        <ResultBody
                            id={params.id}
                            type={searchParams.get('type')}
                            supplierId={searchParams.get('supplierId')}
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default withNamespaces()(ResultDetailPage);